import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const ProjectExpoPrakalp2026 = () => {

    const expoImages = [
        "1.png",
        "2.png",
        "3.png",
        "4.png",
        "5.png",
        "6.png",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">

                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">

                                <div className="how-to-apply">

                                    <h2>
                                        Project Expo – Prakalp-2026
                                    </h2>

                                    <div className='py-2'>
                                        <p>
                                            A One-day Project Expo Conducted for BTech IT III-II students,
                                            where participants showcased and demonstrated their innovative
                                            projects. The expo provided students with an excellent platform
                                            to enhance their research, presentation, technical, and
                                            communication skills while encouraging creativity and teamwork.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>

                                    <div className="spotlight-group">
                                        <div className="row">

                                            {expoImages.map((img, index) => (
                                                <div
                                                    key={index}
                                                    className="col-md-6 mb-3 mb-lg-4"
                                                >
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/project-expo-prakalp-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/project-expo-prakalp-2026/${img}`}
                                                            alt={`Project Expo Prakalp 2026 Image ${index + 1}`}
                                                            className="img-responsive center-block sixteen-nine rounded"
                                                        />
                                                    </a>
                                                </div>
                                            ))}

                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ProjectExpoPrakalp2026;